import { isEmail } from 'validator';

import jsonValidator from '../../helpers/jsonValidator';

const newsletterSchema = {
  type: 'object',
  properties: {
    email: { type: 'string' }
  },
  required: ['email'],
  additionalProperties: false
};

export const validateSubmit = (newsletter) => {
  const errors = jsonValidator.validateForUI(
    newsletterSchema,
    newsletter,
    customValidate(newsletter)
  );
  return errors;
};

const customValidate = (newsletter) => {
  const errorArray = [];
  if (newsletter.email && !isEmail(newsletter.email)) {
    const error = { field: `email`, message: 'Invalid Email' };
    errorArray.push(error);
  }
  return errorArray;
};
